import React from 'react'
import { useNavigate } from 'react-router-dom';
import logo from '../assets/imgs/logo.png';
import footerBg from '../assets/imgs/footer.svg';
import { useTranslation } from 'react-i18next';

export default function Footer(props) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <div className="w-full relative mt-[100px]"> 
      <div className="flex flex-col items-center gap-5 absolute top-8 w-full border-t-[1px] border-t-[#24242a] bg-background">
        <div className="flex sm:flex-row flex-col sm:gap-[100px] gap-3 justify-center py-10">
          <div className="flex flex-col gap-3">
            <div className="flex flex-row gap-2 items-center">
              <img src={logo} alt="logo" className="w-[36px] h-[36px]"/>
              <div className="text-primary text-[30px] font-bold">UNIVERSE</div>
            </div>
            <div className="flex flex-row gap-4">
              <div className="border-[2px] border-[#24242a] pt-[10px] p-2  rounded-md">
                <a href="https://x.com/bitcoinunified" className="" target="_blank">
                  <img src="https://mscribe-webapp.s3.amazonaws.com/twitter.png" alt="Twitter" className="cursor-pointer sm:w-[30px] w-[30px] " />
                </a>
              </div>
              <div className="border-[2px] border-[#24242a] pt-[10px] p-2 rounded-md">
                <a href="https://discord.com/invite/Auq977wfM8" className="" target="_blank">
                  <img src="https://mscribe-webapp.s3.amazonaws.com/discord.png" alt="Discord" className="cursor-pointer sm:w-[30px] w-[30px]" />
                </a>
              </div>
              <div className="border-[2px] border-[#24242a] p-2 rounded-md">  
              <a href="https://t.me/bitcoinunified"  target="_blank">
                <span className="text-[30px] text-white rounded-full">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><path d="M231.3,31.7A16.1,16.1,0,0,0,215,29L30.4,101.5a15.8,15.8,0,0,0-10.1,16.3,16,16,0,0,0,12.8,14.3L80,141.4V200a16,16,0,0,0,9.9,14.8A16.6,16.6,0,0,0,96,216a15.8,15.8,0,0,0,11.3-4.7l26-25.9L172.6,220a16,16,0,0,0,10.5,4,14.2,14.2,0,0,0,5-.8,15.9,15.9,0,0,0,10.7-11.6L236.4,47.4A16,16,0,0,0,231.3,31.7ZM183.2,208l-82.4-72.5L219.5,49.8Z"></path></svg>
                  </span>
                </a>
              </div>
            </div>  
          </div>
          <div className="flex flex-col gap-3 mt-2">
            <div className="text-white text-[20px] font-semibold">
              {t('About Universe')}
            </div>
            <div className="cursor-pointer hover:text-primary text-white" onClick = {() => {navigate("/privacy-policy")}}>{t('Privacy Policy')}</div>
            <div className="cursor-pointer hover:text-primary text-white" onClick = {() => {navigate("/terms-of-service")}}>{t('Terms of Service')}</div>
          </div>
          <div className="flex flex-col gap-3 mt-2">
            <div className="text-white text-[20px] font-semibold">
              {t('Resources')}
            </div>
            <div className="cursor-pointer hover:text-primary text-white" onClick = {() => {window.open("https://docs.bitcoinuniverse.io", "_blank")}}>{t('API Documentation')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
